import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ICustomUrl } from "@edp-models/deep-link.model";
import { DeepLinkService } from "@edp-services/deep-link.service";

@Component({
    selector: "edp-deep-link",
    templateUrl: "./edp-deep-link.component.html"
})
export class EdpDeepLinkComponent {
    constructor(private state: ActivatedRoute, private deepLinkService: DeepLinkService) {
        let configuredLink: ICustomUrl;

        this.deepLinkService.getAll().subscribe(
            (links: ICustomUrl[]) => {
                const currentUrl = this.state.snapshot.url[0].path;
                configuredLink = this.deepLinkService.getConfiguredLink(links, currentUrl);

                if (!configuredLink) {
                    this.deepLinkService.redirectToDefaultRoute();
                    return;
                }

                this.deepLinkService.checkRouteTypeAndRedirect(configuredLink, null, this.state.snapshot.url);
            },
            () => this.deepLinkService.redirectToDefaultRoute()
        );
    }
}
